import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import Dropzone from 'react-dropzone';
import LinearProgress from 'material-ui/LinearProgress';
import LoadingIndicator from '../Navigation/LoadingIndicator';

class ProductPictureDialog extends React.Component {

  constructor(props) {
    super(props);

    this.initalState = {
      progress: 0,
      uploadRunning: false,
      convertingRunning: false
    };

    this.state = {
      ...this.initalState
    };
  }

  componentDidMount = () => {
    const {categoryKey, productKey, firebase} = this.props;
    if (productKey && categoryKey && firebase && !this.productPicturesRef) {
      this.productPicturesRef = firebase.database().ref(`portfolio/${categoryKey}/products/${productKey}/pictures`);
      this.productPicturesRef.on('child_added', this.pictureAdded);
    }
  }

  componentWillUnmount = () => {
    if (this.productPicturesRef) {
      this.productPicturesRef.off('child_added');
    }
  }

  handleCancel = () => {
    this.setState({...this.initalState});
    this.props.handleClose();
  }

  onDrop = (acceptedFiles) => {
    const {firebase, productKey, categoryKey} = this.props;
    this.setState({uploadRunning: true});

    acceptedFiles.forEach((file) => {
      const filename = `${new Date().getTime()}.${file.name.split('.').pop()}`;
      const upload = firebase.storage().ref().child(`images_uploaded/${categoryKey}/products/${productKey}/${filename}`).put(file);
      upload.on('state_changed', this.handleUploadStateChange, this.handleUploadError, this.handleUploadSuccess.bind(this, upload.snapshot.ref.location.path));
    });
  }

  handleUploadStateChange =  (snapshot) => {
    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    this.setState({progress});
  }

  handleUploadError = (error) => {console.error(error);} // eslint-disable-line
  //moved to the cloud function imageConversion
  handleUploadSuccess = (location) => {
    //Timeout for imageUpload Process to be shown
    setTimeout(function() {
      const {firebase} = this.props;
      firebase.database().ref('portfolio/images_uploaded').push({location}, () => {
        this.setState({uploadRunning: false, convertingRunning: true});
      });
    }.bind(this), 500);
  }

  pictureAdded = () => {
    if (this.state.convertingRunning) {
      this.handleCancel();
    }
  }

  render() {
    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('close')}
        onTouchTap={this.handleCancel}
      />
    ];

    const dropzone = (this.state.uploadRunning || this.state.convertingRunning) ? null : (<center>
          <Dropzone accept='image/*' multiple={true} onDrop={this.onDrop} style={{width: '100%', border: '2px dashed #eee', borderRadius: '10px'}}>
            <br />
              <p>{t('uploadHelp')}</p>
            <br />
          </Dropzone>
        </center>);

    const progressbar = this.state.uploadRunning ? <LinearProgress mode='determinate' value={this.state.progress} /> : null;

    const convertingIndicator = this.state.convertingRunning ? <LoadingIndicator display='flex' title={t('uploadDone')}/> : null;

    const dialogTitle = this.state.convertingRunning ? t('uploadDone') : t('product.uploadPicture');

    return (
      <Dialog
          title={dialogTitle}
          open={this.props.open}
          onRequestClose={this.handleCancel}
          actions={actions}
        >
        {dropzone}
        {progressbar}
        {convertingIndicator}
        </Dialog>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(ProductPictureDialog);



// WEBPACK FOOTER //
// ./src/Admin/ProductPictureDialog.js